<template>
  <!-- 我要提问 -->
  <div id="content" class="container">
    <div class="all-right-wrap">
      <div class="question-right-wrap">
        <div class="ask-question-wrap">
          <div>
            <el-button class="ask-btn"
                      @click="handleAsk">我要提问</el-button>
          </div>
          <!-- 分类 -->
          <div class="all-list-wrap">
            <a class="list-tag"
              :class="currentIndex === null?'tag-checked':''"
              @click="handleClick(null)">全部</a>
            <a class="list-tag"
              :class="currentIndex===index?'tag-checked':''"
              v-for="(item,index) in labelList"
              :key="item.id"
              @click="handleClick(item.id,index)">{{item.typeAttributeValue}}</a>
          </div>
        </div>
        <!-- 热门问答 -->
        <div class="hot-question">
          <h4>热门问答推荐</h4>
          <div class="hot-question-list">
            <ul>
              <li v-for="(data,index) in dataList"
                  :key="data.id">
                <div class="hot-question-title"
                    @click="handleDetail(data.id)">
                  <span v-if="index === 0"><img :src="imgUrl1" /></span>
                  <span v-if="index === 1"><img :src="imgUrl2" /></span>
                  <span v-if="index === 2"><img :src="imgUrl3" /></span>
                  <span v-if="index >= 3">{{index+1}}.</span>
                  <span class="hot-title"> {{data.questionTitle}}</span>
                </div>
                <div class="hot-question-answear">
                  <span>回答数</span>
                  <span class="red">{{data.replyCount}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      dataList: [],
      labelList: [],
      imgUrl1: require('@/assets/img/1_03.png'),
      imgUrl2: require('@/assets/img/2_03.png'),
      imgUrl3: require('@/assets/img/3_03.png'),
      currentIndex: this.$route.query.childIndex != null ? Number(this.$route.query.childIndex) : null,
      all: true
    }
  },
  mounted () {
    this.getDataList()
    this.getLabel()
  },
  methods: {
    getDataList () {
      this.$http.get(`/front/train/trainQuestionAnswer/recommendHotQaList`).then(({ data: res }) => {
        this.dataList = res.data
      })
    },
    getLabel () {
      this.$http.get(`/front/train/trainAttribute/selectAllAttrbute`)
        .then(({ data: res }) => {
          this.labelList = res.data
        })
    },
    handleClick (id, index) {
      this.$emit('myevent', {
        id: id,
        index: index
      })
      this.currentIndex = index
      if (id === null) {
        this.currentIndex = null
      }
      // if (this.currentIndex === null) {
      //   this.$router.push({ name: 'postBarList' })
      // } else {
      //   this.$router.push({ name: 'postBarList', query: { tagId: id, tagIndex: index || index === 0 ? this.currentIndex : null } })
      // }
    },
    setSearch (index) {
      this.currentIndex = Number(index)
    },
    handleAsk () {
      if (getAccessToken()) {
        this.$router.push({ name: 'toAsk' })
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
      }
    },
    handleDetail (id) {
      this.$router.push({ name: 'questionInfo', query: { id: id } })
    }
  }
}
</script>
<style scoped lang="scss">
.all-right-wrap {
  width: 300px;
  float: right;
  min-height: 696px;
  // margin-top:60px;
}
.question-right-wrap {
  width: 300px;
  height: 666px;
}
.all-list-wrap {
  margin-top: 10px;
  height: auto;
  padding: 0 5px;
}
.all-list-wrap::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.list-tag {
  background: #f5f5f5;
  color: #999;
  float: left;
  font-size: 12px;
  height: 30px;
  line-height: 10px;
  padding: 10px 10px;
  margin-right: 5px;
  margin-bottom: 5px;
}
.hot-question {
  margin: 20px 0;
  text-align: left;
  border-bottom: 1px solid #e2e2e2;
  height: 34px;
  background: #fff;
  min-height: 473px;
}
.hot-question h4 {
  line-height: 40px;
  padding: 0 20px;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #ccc;
}
.hot-question-list {
  width: 280px;
  height: 473px;
}
.hot-question-list ul {
  width: 280px;
  height: 473px;
}
.hot-question-list ul li {
  height: 46px;
  line-height: 46px;
  width: 280px;
}
.hot-question-title {
  float: left;
  width: 170px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 15px;
  cursor: pointer;
}
.hot-question-title span img {
  width: 20px;
  height: 20px;
  margin-left: -7px;
}
.hot-question-title:hover {
  color: #1d65a8;
}
.hot-question-answear {
  float: right;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.hot-question-answear .red {
  color: #ff3116;
}
.ask-question-wrap {
  width: 100%;
  min-height: 150px;
  margin-bottom: 10px;
  background: #fff;
  height: auto;
}
.tag-checked {
  background: #1d65a8;
  color: #fff !important;
}
.ask-btn {
  width: 300px;
  height: 80px;
  background:#1D65A8;
  border:1px solid #1D65A8;
  color:#fff;
  font-size: 22px;
}
</style>
